import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', password: '' });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form.email, form.password, form.name);
      toast.success('Welcome to the family!');
      navigate('/');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Registration failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center bg-[#F8F9FA] py-16">
      <div className="max-w-md mx-auto px-6 w-full">
        <div className="card-tactile p-8">
          <h1 className="font-serif text-3xl text-royal font-bold text-center">Create Account</h1>
          <p className="text-center text-charcoal-muted text-sm mt-2 mb-6">Join the Wisconsin First member community.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block text-sm font-semibold text-royal mb-1">Full Name</label>
              <input data-testid="register-name" required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-royal/40" />
            </div>
            <div>
              <label className="block text-sm font-semibold text-royal mb-1">Email</label>
              <input data-testid="register-email" required type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-royal/40" />
            </div>
            <div>
              <label className="block text-sm font-semibold text-royal mb-1">Password</label>
              <input data-testid="register-password" required type="password" minLength={6} value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-royal/40" />
            </div>
            <button data-testid="register-submit-btn" disabled={busy} type="submit" className="btn-royal w-full justify-center">{busy ? 'Creating...' : 'Create Account'}</button>
          </form>
          <div className="text-center text-sm text-charcoal-muted mt-6">Have an account? <Link to="/login" className="text-royal font-semibold hover:text-gold">Sign in</Link></div>
        </div>
      </div>
    </div>
  );
}
